import React from 'react';
import Card from './Card';
import type { Player } from '../types/game';

interface PlayerListProps {
  players: Player[];
  isRevealed: boolean;
  currentPlayerId: string | null;
}

const RADIUS_PERCENT = 42;

const PlayerList: React.FC<PlayerListProps> = ({ players, isRevealed, currentPlayerId }) => {
  if (!players.length) {
    return (
      <div className="player-ring__empty" role="status">
        Waiting for teammates to join the table…
      </div>
    );
  }

  return (
    <div className="player-ring">
      {players.map((player, index) => {
        const angle = (2 * Math.PI * index) / players.length - Math.PI / 2;
        const x = 50 + RADIUS_PERCENT * Math.cos(angle);
        const y = 50 + RADIUS_PERCENT * Math.sin(angle);
        const isCurrent = player.id === currentPlayerId;

        return (
          <div
            key={player.id}
            data-player-id={player.id}
            className={`player-seat${isCurrent ? ' player-seat--current' : ''}${player.hasVoted ? ' player-seat--locked' : ''}`}
            style={{ left: `${x}%`, top: `${y}%` }}
          >
            <Card
              value={player.vote ?? ''}
              showValue={isRevealed}
              disabled
              className="card--table"
              isSelected={isCurrent && player.hasVoted}
            />
            <div className="player-name">{player.name}</div>
            {!isRevealed && (
              <div className={`player-status${player.hasVoted ? ' player-status--ready' : ' player-status--voting'}`}>
                {player.hasVoted ? 'Ready' : 'Thinking…'}
              </div>
            )}
            {isRevealed && player.vote && (
              <div className="player-result" aria-live="polite">
                {player.vote}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PlayerList;
